export default __webpack_public_path__ + "static/vc_left-b2bb1fa20e203fbf8f8e5e931400b1d7.png";